import { useParams } from "react-router-dom";
import { Coverage } from "../enums/Coverage";

export function useCoverage(): Coverage {
    const { coverage } = useParams();

    return coverage as Coverage;
}